// actions/fishing.ts — M1
import { defineAction, type Ok } from '../define';
import { g } from '../guard';
import type { Vec2 } from '../../types/geom';
import type { HourKey, ItemId } from '../../types/ids';
import type { ItemView } from '../../types/items';
import type { FishShadowView } from '../../types/yields';
declare module '../registry' {
  interface ActionMap {
    'fish.shadows': { req: Record<string, never>; res: { hourKey: HourKey; shadows: FishShadowView[] } };
    'fish.cast': { req: { shadow: string; at: Vec2 }; res: { cast: string; biteInMs: number; nibbles: number } };
    'fish.reel': { req: { cast: string; reactMs: number }; res: { result: 'caught' | 'missed' | 'early'; item: ItemView | null; size: number | null } };
    'fish.release': { req: { item: ItemId }; res: Ok };
    'fish.cancel': { req: { cast: string }; res: Ok };
  }
}
// g.obj({}) returns Guard<{}>; the `as never` cast adapts it to Guard<Record<string, never>> — the guard still rejects every key.
export const fishShadows = defineAction('fish.shadows', g.obj({}) as never);
export const fishCast = defineAction('fish.cast', g.obj({ shadow: g.token, at: g.vec2 }));
export const fishReel = defineAction('fish.reel', g.obj({ cast: g.token, reactMs: g.int(0, 10_000) }));
export const fishRelease = defineAction('fish.release', g.obj({ item: g.id<ItemId>('i') }));
export const fishCancel = defineAction('fish.cancel', g.obj({ cast: g.token }));
